// Matches the spreadsheet grid's batch poller (MAX_POLL_RETRIES, 8s backoff).
const MAX_STATUS_POLL_FAILURES = 5;
const STATUS_POLL_RETRY_DELAY_MS = 8000;

/**
 * An accepted batch may still finish while its status endpoint is briefly
 * unavailable. Failing its cells then would invite the user to pay for the same
 * work again, so transient errors retry; anything else stops polling.
 *
 * @param {number|undefined} status HTTP status of the failed poll, if any.
 * @param {number} failures Consecutive failed polls before this one.
 * @returns {number|null} Delay before the next poll, or null to stop.
 */
export function statusPollRetryDelay(status, failures) {
  const transient = !status || status === 408 || status === 429 || status >= 500;
  if (!transient || failures + 1 >= MAX_STATUS_POLL_FAILURES) return null;
  return STATUS_POLL_RETRY_DELAY_MS;
}
